/**
 * Get default error message based on HTTP method and status code
 */
export const getDefaultErrorMessage = (method: string, status?: number): string => {
  // Network errors (status 0 or undefined)
  if (!status || status === 0) {
    return "Nätverksfel uppstod. Kontrollera din internetanslutning.";
  }

  // Method-specific messages
  const upperMethod = method?.toUpperCase();
  switch (upperMethod) {
    case "GET":
      return "Hämtning av data misslyckades.";
    case "POST":
      return "Skapande av data misslyckades.";
    case "PUT":
    case "PATCH":
      return "Uppdatering av data misslyckades.";
    case "DELETE":
    case "DEL":
      return "Borttagning av data misslyckades.";
    default:
      return "Ett oväntat fel har inträffat. Försök igen.";
  }
};
